import _ from 'lodash'

const baseController = 'elementosnutricionales'

const baseIndex = baseController + '/index'

const archetype = [
     // [hidden|number|price|phone|textarea|positivo|password|email]
    {
        key: 'id_pk',
        type: 'hidden'
    },
    [
        {
            key: 'nombre',
        }
    ],
    [
        {
            key: 'idcategorianutricion_fk',
            label: 'Categoria',
            type: 'select',
            options: []
        }
    ],
    [
        {
            key: 'unidaddemediciontextual',
            label: 'Unidad de medición textual'
        }
    ]
];

const captions = [
    {key: 'elementonutricional',        label: 'Elemento nutricional'},
    {key: 'categoria',                  label: 'Categoria'},
    {key: 'unidaddemediciontextual',    label: 'Unidad de medición'},
    {key: 'ultima_actualizacion',       label: 'Última actualización'},
    {key: '_'},
]

let automodalHandler = (conceptId) => {
    let str = baseController + '/' + 'define' + ((_.isNil(conceptId)) ? '' : ('/' + conceptId) );
    // console.log("isNil", _.isNil(conceptId))
    return str;
}


export {
    archetype,
    captions,
    baseIndex,
    automodalHandler
}